import { ZonedDateTime } from '@internationalized/date';
import type { CalendarProps } from '@react-aria/calendar';
import { DateValue } from '@react-aria/datepicker';
import { DismissButton, useModalOverlay } from '@react-aria/overlays';
import { DatePickerState } from '@react-stately/datepicker';
import { MutableRefObject } from 'react';

import { ExpiryCalendar } from '.';

interface CalendarPopoverProps {
  state: DatePickerState;
  now: ZonedDateTime;
  calendarProps: CalendarProps<DateValue>;
  popoverRef: MutableRefObject<HTMLDivElement | null>;
}
/**
 * Calendar Popover for custom limit order expiry
 * @param props - CalendarPopover props
 */
export const CalendarPopover = ({
  state,
  now,
  calendarProps,
  popoverRef,
}: CalendarPopoverProps) => {
  const { modalProps } = useModalOverlay(
    {
      isDismissable: true,
    },
    state,
    popoverRef,
  );

  return (
    <div
      className="fixed h-fit w-fit p-4 rounded-md shadow-25 z-100 bg-special-background-modal"
      {...modalProps}
      ref={popoverRef}
    >
      <ExpiryCalendar {...calendarProps} now={now} />
      <DismissButton onDismiss={state.close} />
    </div>
  );
};
